module.exports = __webpack_public_path__ + "img/tg.0ec284d8.svg";